import createMutationsSharer from 'vuex-shared-mutations';
// import LANG from '@/lang/eng';
import globals from '@/globals';

export const copyBroadcaster = createMutationsSharer({
  predicate: [
    'clipboard/copyDocuments',
    'clipboard/clearDocuments',
    'clipboard/removeDocument',
  ],
});

const SessionId = globals.I.settings.session.id;

export default {
  namespaced: true,
  state: {
    [SessionId]: {
      documents: [],
    },
  },
  mutations: {
    copyDocuments(state, documents) {
      state[SessionId].documents = documents;
    },
    clearDocuments(state) {
      state[SessionId].documents = [];
    },
    removeDocument(state, document) {
      state[SessionId].documents = state[SessionId].documents.filter((d) => d.nodeId !== document.nodeId);
    },
  },
  persistence: {
    reducer: (state) => ({ [SessionId]: state[SessionId] }),
    // filter: (mutation) => mutation.type.startsWith('clipboard/'),
  },
};
